/* Carrusel de opiniones: scroll-snap nativo, flechas y progreso */
(function () {
  function init() {
    [].forEach.call(document.querySelectorAll('[data-lp-rv6]'), function (g) {
      var track = g.querySelector('.lp-rv6__track'), prog = g.querySelector('.lp-rv6__prog span');
      var prev = g.querySelector('[data-rv-prev]'), next = g.querySelector('[data-rv-next]');
      function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 16 : 300; }
      function upd() {
        var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
        var vis = track.clientWidth / track.scrollWidth;
        if (prog) { prog.style.width = Math.max(vis * 100, 12) + '%'; prog.style.transform = 'translateX(' + (max > 0 ? (x / max) * (100 / Math.max(vis, 0.12) - 100) : 0) + '%)'; }
        if (prev) prev.disabled = x < 4; if (next) next.disabled = x > max - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * (window.innerWidth >= 1000 ? 3 : 1), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * (window.innerWidth >= 1000 ? 3 : 1), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') next.click(); if (e.key === 'ArrowLeft') prev.click(); });
      window.addEventListener('resize', upd); upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
